module.exports = __webpack_public_path__ + "static/media/Backgroundvideo.a7bf0509.mp4";